import Decimal from 'decimal.js';

export default function calculateTotalAmount(plates, sstInfo, extraCharges, extraChangesOptions) {
  let total = new Decimal(0);
  let sst = new Decimal(0);
  let subtotal = new Decimal(0);

  const extra_changes = Object.keys(extraCharges).reduce((total, key) => {
    let temp_total = new Decimal(total)

    return temp_total.plus(extraChangesOptions[key] ? extraCharges[key] : 0);
  }, 0);

  for (const plate of plates) {
    for (const item of plate.items) {
      let unit_price = new Decimal(item.unit_price ?? 0)

      total = total.plus(unit_price.times(item.quantity ?? 0));
      subtotal = total;
    }
  }

  total = total.plus(extra_changes)
  subtotal = subtotal.plus(extra_changes)

  if (sstInfo.sst_enabled) {
    if (sstInfo.sst_type === "Exclusive") {
      sst = total.times(sstInfo.sst_rate).div(100);
      total = total.plus(sst);
    } else if (sstInfo.sst_type === "Inclusive") {
      let sst_rate = new Decimal(sstInfo.sst_rate)
      
      subtotal = subtotal.div(sst_rate.div(100).plus(1));
      sst = total.minus(subtotal);
    }
  }

  return {
    total: total.toNumber(),
    subtotal: subtotal.toNumber(),
    sst: sst.toNumber(),
  };
}
